import React from "react";

/* Upload — tray with an arrow rising out of it. */
export const UploadIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M12 15V3m0 0L8 7m4-4l4 4" stroke="currentColor" strokeWidth="1.8"
          strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 15v3a3 3 0 003 3h12a3 3 0 003-3v-3" stroke="currentColor"
          strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export default UploadIcon;
